"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.map.js");

var _react = require("react");

var _Tile = _interopRequireDefault(require("ol/layer/Tile"));

var _TileWMS = _interopRequireDefault(require("ol/source/TileWMS"));

var _NewLayerForm = _interopRequireDefault(require("../NewLayerForm/NewLayerForm"));

var _GeneralTab = _interopRequireDefault(require("../../tabs/general/GeneralTab/GeneralTab"));

var _TileWMSSourceTab = _interopRequireDefault(require("../../tabs/source/TileWMSSourceTab/TileWMSSourceTab"));

var _common = require("../../../../../util/common");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["source"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var defaultTileWMSLayerOpts = {
  opacity: 1,
  maxResolution: Infinity,
  maxZoom: Infinity,
  minResolution: 0,
  minZoom: -Infinity,
  visible: true,
  zIndex: 0,
  name: 'unnamed layer',
  source: {
    imageSmoothing: true,
    opaque: true,
    wrapX: true,
    hidpi: true,
    gutter: 0,
    params: {
      FORMAT: 'image/png',
      STYLES: '',
      VERSION: '1.1.1',
      FEATURE_COUNT: 50
    }
  }
};

var NewTileWMSLayerForm = function NewTileWMSLayerForm(_ref) {
  var map = _ref.map,
      _ref$parentLayerGroup = _ref.parentLayerGroup,
      parentLayerGroup = _ref$parentLayerGroup === void 0 ? undefined : _ref$parentLayerGroup,
      _ref$layerOpts = _ref.layerOpts,
      layerOpts = _ref$layerOpts === void 0 ? defaultTileWMSLayerOpts : _ref$layerOpts,
      _ref$onFinish = _ref.onFinish,
      onFinish = _ref$onFinish === void 0 ? undefined : _ref$onFinish;
  var onInternalFinish = (0, _react.useCallback)(function (values) {
    (0, _common.normalizeStringInObject)(values);
    (0, _common.normalizeStringInObject)(values.source);
    (0, _common.normalizeStringInObject)(values.source.params);

    var source = values.source,
        baseOpts = _objectWithoutProperties(values, _excluded);

    var layer = new _Tile.default(_objectSpread(_objectSpread({}, baseOpts), {}, {
      source: new _TileWMS.default(source)
    })); //add layer to the map

    if (parentLayerGroup) parentLayerGroup.getLayers().push(layer);else map.addLayer(layer); //execute onFinish

    onFinish && onFinish();
  }, [map, parentLayerGroup, onFinish]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_NewLayerForm.default, {
    layerOpts: layerOpts,
    onFinish: onInternalFinish //GeneralTab={GeneralTab}
    //SourceTab={ImageWMSSourceTab}
    ,
    tabs: [{
      title: "General",
      key: "general",
      isDefault: true,
      el: _GeneralTab.default
    }, {
      title: "Source",
      key: "source",
      el: _TileWMSSourceTab.default
    }]
  });
};

var _default = NewTileWMSLayerForm;
exports.default = _default;